export const PATH_RESERVATION_PENALTY = `/reservation-penalty`;

export function fetchReservationPenaltyHistory(penltyId) {
  return this.http.get(`${PATH_RESERVATION_PENALTY}/${penltyId}/history`);
}